import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useNavigate, Link } from "react-router-dom";
import "./App2.css"; // Hier ist auch die Lauflicht-CSS drin
import spinSound from "./assets/spin.mp3"; // <– Pfad ggf. anpassen

const symbols = ["🍒", "🔔", "7️⃣", "🍋", "💎"];

const SlotMachinePage = () => {
  const navigate = useNavigate();

  const goToMainPage = () => {
    navigate("/"); // Navigiert zurück zur Root-Route ("/")
  };

  const [step, setStep] = useState("seite2");
  const [reels, setReels] = useState(["❓", "❓", "❓", "❓"]);
  const [spinning, setSpinning] = useState(false);
  const [lightIndex, setLightIndex] = useState(0);
  const soundRef = useRef(null);

  const goToSeite3 = () => setStep("seite3");
  const goToSeite2 = () => setStep("seite2");

  useEffect(() => {
    const interval = setInterval(() => {
      setLightIndex((prev) => (prev + 1) % 8); // 8 Lichter rotieren
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const spinReels = () => {
    if (soundRef.current) {
      soundRef.current.currentTime = 0;
      soundRef.current.play();
    }

    setSpinning(true);
    let spins = 20;
    const interval = setInterval(() => {
      setReels([
        symbols[Math.floor(Math.random() * symbols.length)],
        symbols[Math.floor(Math.random() * symbols.length)],
        symbols[Math.floor(Math.random() * symbols.length)],
        symbols[Math.floor(Math.random() * symbols.length)],
      ]);
      spins--;
      if (spins <= 0) {
        clearInterval(interval);
        setSpinning(false);
      }
    }, 100);
  };

  if (step === "seite2") {
    return (
      <div className="container text-center py-5">
        <h1>Zweite Seite</h1>
        <button className="btn btn-warning" onClick={goToSeite3}>
          Zum Spielautomaten
        </button>
      </div>
    );
  }
  else if (step === "seite3") {
  return (
    <div className="container text-center py-5">
      <h1>🎰 Spielautomat 🎰</h1>

      <div className="slot-wrapper my-4 mx-auto position-relative">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className={`light-dot ${lightIndex === i ? "active" : ""}`}
          ></div>
        ))}

        <div className="d-flex justify-content-around fs-1 bg-white border rounded p-3">
          {reels.map((symbol, idx) => (
            <span key={idx}>{symbol}</span>
          ))}
        </div>
      </div>

      <button className="btn btn-danger mb-3" onClick={spinReels} disabled={spinning}>
        {spinning ? "Dreht..." : "Drehen"}
      </button>
      <br />
      <button className="btn btn-secondary me-2" onClick={goToSeite2}>
        Zurück zu Seite 2
      </button>

      {/*
      <button className="btn btn-outline-primary" onClick={goToMainPage}>
      </button>
      */}
      <button className="btn btn-outline-primary" onClick={() => navigate("/")}>
        Zur Hauptseite
      </button>

      <audio ref={soundRef} src={spinSound} />
    </div>
  );
}
};

export default SlotMachinePage;
